export const oppTypesMap = {
  RE: {
    chainPageUrl: '/chain/',
  },
  CU: {
    chainPageUrl: '/university/',
  },
  DI: {
    chainPageUrl: '/k12/',
  },
  HO: {
    chainPageUrl: '/hospital/',
  },
  NH: {
    chainPageUrl: '/nursinghome/',
  },
  LG: {
    chainPageUrl: '/lodging/chain/',
  },
  CS: {
    chainPageUrl: '/convenience/chain/',
  },
  UG: {
    chainPageUrl: '/company/',
  },
} as const

/**
 * Get the page URL for a company given its full FirstBite ID.
 *
 * @param firstbiteId - Full ID including type prefix (e.g., "RE123456", "CU789", "UG123")
 * @returns The full URL path to the company page (e.g., "/chain/RE123456")
 */
export const getCompanyPageUrl = (firstbiteId: string): string => {
  const oppType = firstbiteId.substring(0, 2) as keyof typeof oppTypesMap
  const baseUrl = oppTypesMap[oppType]?.chainPageUrl ?? '/company/'
  return `${baseUrl}${firstbiteId}`
}
